"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = EmployeesStatusChartCard;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const Theme_1 = require("../Theme");
const ThemeContext_1 = require("../ThemeContext");
const UserContext_1 = require("../contexts/UserContext");
const Card_1 = __importDefault(require("../components/Card"));
const CardTitle_1 = __importDefault(require("../components/CardTitle"));
const react_i18next_1 = require("react-i18next");
const cancelable_promise_1 = require("cancelable-promise");
const Employees_1 = __importDefault(require("../api/Employees"));
const Loading_1 = __importDefault(require("../components/Loading"));
const GiftedCharts_1 = __importDefault(require("../shared/GiftedCharts"));
const Helper_1 = require("../Helper");
const TableHeader_1 = __importDefault(require("../components/TableHeader"));
const ChartLegendItem_1 = __importDefault(require("./ChartLegendItem"));
const ResponsiveContext_1 = require("../contexts/ResponsiveContext");
function EmployeesStatusChartCard(props) {
    const { t } = (0, react_i18next_1.useTranslation)();
    const THEME = (0, ThemeContext_1.useTheme)();
    const ChartColors = (0, Theme_1.useChartColors)();
    const PieChart = GiftedCharts_1.default.PieChart;
    const userContext = react_1.default.useContext(UserContext_1.UserContext);
    const { size } = (0, ResponsiveContext_1.useResponsiveContext)();
    const promise = react_1.default.useRef(null);
    const [status, setStatus] = react_1.default.useState('loading');
    const [statusPieData] = react_1.default.useState([]);
    const refresh = react_1.default.useCallback(() => {
        promise.current?.cancel();
        setStatus('loading');
        promise.current = (0, cancelable_promise_1.cancelable)(userContext.getToken().then((token) => {
            Employees_1.default.getEmployeeStatuses(token).then((r) => {
                let colorIndex = 0;
                r.sort((a, b) => (a?.eeCount > b?.eeCount ? -1 : 1));
                r.forEach(status => {
                    if (status.eeCount > 0) {
                        statusPieData.push({
                            value: status.eeCount,
                            text: Helper_1.Helper.FormatTitleCase(status.name),
                            color: ChartColors[colorIndex]
                        });
                        ++colorIndex;
                    }
                });
                setStatus('done');
            });
        }).catch(() => {
            setStatus('error');
        }));
    }, []);
    react_1.default.useEffect(() => {
        refresh();
        return () => {
            promise.current?.cancel();
        };
    }, []);
    return ((0, jsx_runtime_1.jsxs)(Card_1.default, { children: [(0, jsx_runtime_1.jsx)(CardTitle_1.default, { title: t('employees:text.employeesByStatus'), style: { marginBottom: 8 } }), (status == 'done' && ((0, jsx_runtime_1.jsxs)(react_native_1.View, { style: {
                    margin: 12,
                    alignItems: 'center',
                }, children: [(0, jsx_runtime_1.jsx)(PieChart, { data: statusPieData, donut: true, innerRadius: size != 'sm' ? 65 : 56, radius: size != 'sm' ? 105 : 90, innerCircleColor: THEME.CardBackground }), (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: {
                            flex: 1,
                            width: '100%',
                            marginTop: 18
                        }, children: [(0, jsx_runtime_1.jsx)(TableHeader_1.default, { style: { marginBottom: 6, width: '100%' }, columns: [
                                    { flex: 2, label: t('employees:text.empStatus'), align: 'flex-start', indent: 30 },
                                    { flex: 1, label: t('employees:text.employees'), align: 'center', textStyle: { textAlign: 'center' }, indent: 4 },
                                ] }), statusPieData.map((item, index) => (item.value != 0 &&
                                (0, jsx_runtime_1.jsx)(ChartLegendItem_1.default, { item: item, pressable: false }, index)))] })] }))) || (0, jsx_runtime_1.jsx)(Loading_1.default, { retryable: true, loading: status == 'loading', error: status == 'error', onRetry: () => refresh() })] }));
}
;
